export const API_URLS = {
    advice: '/api/advice',
    courses: '/umbraco/api/courseapi/getcoursesundernode',
    favourites: '/umbraco/api/favouritesapi/postfavouriteupdate',
    landscapers: '/umbraco/api/aplmembersapi/getlandscapers',
    landscapersTypeahead: '/umbraco/api/aplmembersapi/getlandscaperstypeahead',
    members: '/umbraco/api/memberslistingapi/getmembers',
    supportersFull: '/umbraco/api/memberslistingapi/GetSupporters?supporterTypeFilter=full',
    supportersProv: '/umbraco/api/memberslistingapi/GetSupporters?supporterTypeFilter=provisional',
    memberLocations: '/api/memberLocations',
    events: '/umbraco/api/eventsapi/geteventsundernode',
    news: '/umbraco/api/articlesapi/getarticlesundernode',
    preferences: '/umbraco/api/accountapi/updatepreferences',
    profile: '/umbraco/api/teammemberapi/getteammemberbio',
    projects: '/umbraco/api/projectsapi/getprojectsundernode',
    resources: '/umbraco/api/resourcesapi/getresourcesundernode',
    mydocuments: '/umbraco/surface/documentsapi/getdocuments',
    typeahead: '/umbraco/api/typeahead/getsearch',
    products: '/umbraco/api/productsapi/getproductsundernode',
    accountdetails: '/umbraco/api/accountapi/updatedetails',
    pages: '/umbraco/api/pagesapi/getpagesundernode',
    // APL Dashboard APIs
    createAccountDetails: '/api/accountdetails',
    readAccountDetails: '/api/accountdetails',
    updateAccountDetails: '/api/accountdetails',
    deleteAccountDetails: '/api/accountdetails',
    createProject: '/api/project',
    readProject: '/api/project',
    updateProject: '/api/project',
    deleteProject: '/api/project',
    createPublicProfile: '/api/publicprofile',
    readPublicProfile: '/api/publicprofile',
    updatePublicProfile: '/api/publicprofile',
    deletePublicProfile: '/api/publicprofile',
    createTeam: '/api/teammember',
    readTeam: '/api/teammember',
    updateTeam: '/api/teammember',
    deleteTeam: '/api/teammember',
    createTestimonial: '/api/testimonial',
    readTestimonial: '/api/testimonial',
    updateTestimonial: '/api/testimonial',
    deleteTestimonial: '/api/testimonial',
    // Account Area APIs
    accountProducts: '/umbraco/api/storeproductsapi/searchproducts',
    checkout: '/umbraco/api/ordersapi/createorder',
    updateBasket: '/umbraco/api/basketapi/update',
    updateBasketBulk: '/umbraco/api/basketapi/bulkupdate',
    orders: '/umbraco/api/ordersapi/searchorders',
};
